// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__133j5","icon":"styles_icon__2ZA1y"};